export enum FieldsName {
  url = 'url',
}

export type FieldsType = {
  [FieldsName.url]: string;
};
